<template>
  <DashboardChartWrapper
    title="CA par vendeur"
    :loading="loading"
    :error="error"
    @retry="refresh"
  >
    <Bar v-if="chartData" :data="chartData" :options="chartOptions" />
  </DashboardChartWrapper>
</template>

<script setup>
import { computed } from 'vue'
import { Bar } from 'vue-chartjs'
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Tooltip, Legend } from 'chart.js'
import { useDashboard } from '@/composables/useDashboard'
import { useDateRange } from '@/composables/useDateRange'
import { formatCurrency } from './helpers'
import DashboardChartWrapper from './DashboardChartWrapper.vue'

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend)

const { dateParams } = useDateRange()
const { data, loading, error, refresh } = useDashboard('/dashboard/charts/revenue-by-user', dateParams)

const chartData = computed(() => {
  if (!data.value || !Array.isArray(data.value)) return null
  return {
    labels: data.value.map(d => d.label),
    datasets: [{
      label: 'CA TTC',
      data: data.value.map(d => d.revenue_ttc),
      backgroundColor: '#3b82f6',
      borderRadius: 4
    }]
  }
})

const chartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  indexAxis: 'y',
  plugins: {
    legend: { display: false },
    tooltip: {
      callbacks: {
        label: (ctx) => `CA TTC: ${formatCurrency(ctx.raw)}`
      }
    }
  },
  scales: {
    x: { ticks: { callback: v => formatCurrency(v) } },
    y: { grid: { display: false } }
  }
}
</script>
